module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraLightItalic.1170df55.ttf";